import { render, staticRenderFns } from "./InProduct.vue?vue&type=template&id=5ac72ad6&scoped=true&"
import script from "./InProduct.vue?vue&type=script&lang=js&"
export * from "./InProduct.vue?vue&type=script&lang=js&"
import style0 from "./InProduct.vue?vue&type=style&index=0&id=5ac72ad6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac72ad6",
  null
  
)

export default component.exports